// GENERATED by tools/fiscal-perimeter.mjs --record — do not edit. The fiscal perimeter (référentiel E20, E21).
export const FISCAL_PERIMETER = { version: '0.12', fingerprint: 'e6412e9d15d3d8e60b261cde154e298cefa5b984c4bd9631ca71ab4257a3a016', fileCount: 44 } as const;
